import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';

import { UserStore } from 'four-nets/user/user';
import ErrorPage from 'four-nets/errors/error-page';
import { ThreadsTableViewModel } from 'four-nets/forum/threads-table/threads-table-view';

import { CategoryStore } from '../forum';
import WhereIPostedView from './where-i-posted-view';

class WhereIPostedLoader extends React.Component {
    static contextTypes = {
        app: PropTypes.object,
        categoryStore: PropTypes.instanceOf(CategoryStore),
        userStore: PropTypes.instanceOf(UserStore),
    };

    transform = data => {
        const { categoryStore } = this.context;

        const threadsTableViewModel = new ThreadsTableViewModel();
        threadsTableViewModel.setThreads(
            categoryStore.threadStore.processPagedJSON({ json: data.threadsTableViewModel.threads })
        );

        threadsTableViewModel.ascending = data.threadsTableViewModel.ascending;

        return {
            threadsTableViewModel,
        };
    };

    fetch = (setData, { asc, page }) => {
        const { categoryStore } = this.context;

        return categoryStore.threadStore.loadWhereIPosted({ page, asc }).then(threads => {
            const threadsTableViewModel = new ThreadsTableViewModel();
            threadsTableViewModel.setThreads(threads);
            threadsTableViewModel.setAscending(asc);

            setData({
                threadsTableViewModel,
            });
        });
    };

    renderFetch = ({ loading, data, error }) => {
        return (
            <LoadingProgress loading={loading}>
                <ErrorPage error={error}>
                    <WhereIPostedView loading={loading} threadsTableViewModel={data?.threadsTableViewModel} />
                </ErrorPage>
            </LoadingProgress>
        );
    };

    render() {
        const { page = 1, asc = false } = this.props.search;

        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                render={this.renderFetch}
                transform={this.transform}
                page={page}
                asc={asc}
                me={this.context.userStore.me}
            />
        );
    }
}

export default observer(WhereIPostedLoader);
